import { cloneElement } from "preact";
import type { FC, ReactNode } from "preact/compat";

type TextReplaceProps = {
  text: string;
  textToReplace: string;
  component: ReactNode;
};
export const TextReplace: FC<TextReplaceProps> = ({
  text,
  textToReplace,
  component,
}) => {
  const re = new RegExp(`(${textToReplace})`, "gi");

  const result = text.split(re);
  return (
    <>
      {result[0]}
      {cloneElement(component as any)}
      {result[2]}
    </>
  );
};
